const { ObjTypes } = require('./types')

module.exports = {
  [ObjTypes.deposit]: require('./qbo-deposit'),
  [ObjTypes.invoice]: require('./qbo-invoice'),
  [ObjTypes.creditmemo]: require('./qbo-creditmemo'),
  [ObjTypes.payment]: require('./qbo-payment'),
  [ObjTypes.journalentry]: require('./qbo-journalentry'),
  [ObjTypes.purchase]: require('./qbo-purchase'),
  [ObjTypes.account]: require('./qbo-account'),
  [ObjTypes.customer]: require('./qbo-customer')
}
